export default __webpack_public_path__ + "static/media/dummy_thumb_5.cc7c35a4.png";